/*
 * Dependencies:
 * - MMM Api
 */

define('components/videofactory/views/MMMVideoView', [
    'components/videofactory/templates/mmmvideoview'
], function(tpl) {

    var MMMVideoView = Mazarine.View.extend({

        events: {
            "click .mmm-big-play-button": "onClickBigPlayButton"
        },

        template: tpl,

        className: "maz-mmm-video-view",

        player: null,

        afterRender: function() {
            this.isMobile = this.model.get('isMobile');
            this.player = null;
            this.videoElement = null;

            var _this = this;
            var self = this;
            var options = {
                id: this.model.get('domId'),
                mmmID: this.model.get('videoId'),
                muted: this.model.get('muted'),
                autoplay: this.model.get('autoplay'),
                poster: this.model.get('poster'),
                subtitles: this.model.get('subtitle'),
                subtitlesOn: this.model.get('subtitleOn') ? true : false,
                tiny: this.model.get('tiny'),
                locale: this.model.get('locale'),
                share: this.model.get('share'),
                logoDiorTV: this.model.get('logoDiorTV')
            };

            if(this.isMobile){
                options.subtitles = this.model.get('subtitleVTT') ? [this.model.get('subtitleVTT')] : [];

                if(typeof window.modules !== 'undefined' && typeof window.modules.Player == 'function'){
                    this.player = new window.modules.Player(document.querySelector('.mmm-player'), options);

                    var playerVideo = $(this.player.video);
                    if (options.subtitles && !playerVideo.find('track').length) {
                        this.player.appendTrack(options.subtitles);
                    }

                    this.videoElement = this.player.video;
                    playerVideo.on('play', _.bind( this.onPlay, this));
                    playerVideo.on('pause', _.bind( this.onPause, this));
                    playerVideo.on('ended', _.bind( this.onEnded, this));
                    playerVideo.on('webkitfullscreenchange mozfullscreenchange fullscreenchange', _.bind(this.onFullscreenChangeMobile, this));

                    this.$('.maz-wrapper-mmm-player').removeClass('loading').addClass('playing');
                }else{
                    console.warn('[HE] - Error "window.modules.Player" is unavailable');
                }
            }else{

                if(typeof window.diorV7 !== 'undefined' && typeof window.diorV7.Player == 'function'){

                    this.$('.mmm-player').data('options', options);
                    this.player = new diorV7.Player(options, this.$('.mmm-player'));

                    this.videoElement = this.player.video;

                    this.player.on('ready', _.bind( this.onReady, this ));
                    this.player.on('play', _.bind( this.onPlay, this));
                    this.player.on('pause', _.bind( this.onPause, this));
                    this.player.on('end', _.bind( this.onEnded, this));
                    this.player.on('enterFullscreen', _.bind(this.onFullscreenChange, this));
                    this.player.on('_onTimeupdate', function(){});

                    // this.player.on('replay', function() { console.log('___replay___'); });

                    var w = this.model.get('videoWidth'),
                        h = this.model.get('videoHeight');

                    this.$('.mmm-player').width(w);
                    this.$('.mmm-player').height(h);

                }else{
                    console.warn('[HE] - Error "window.diorV7.Player" is unavailable');
                }

            }
        },

        destroy: function() {
            var id = this.model.get('videoId');
            if(this.player){
                this.player.destroy(id);
            }
            //TODO: HE must update destroy method to clean also MMM instance
            // delete widemotion.W.ids[id];
            // delete widemotion.W.video_tags[id];
        },

        play: function() {
            if(this.player){
                if(this.isMobile){
                    this.player.video.play();
                }else{
                    this.player.play();
                }
            }
        },

        pause: function() {
            if(this.player){
                this.player.pause();
            }
        },

        stop: function() {
            this.setCurrentTime(0);
            if(this.player){
                this.player.pause();
            }
        },

        toggleFullScreen: function() {
            if(this.player){
                this.player.toggleFullScreen();
            }
        },

        setCurrentTime: function(seconds) {
            if(this.videoElement){
                this.videoElement.currentTime = seconds;
            }
        },

        getCurrentTime: function() {
            return this.videoElement ? this.videoElement.currentTime : false;
        },

        getDuration: function() {
            return this.videoElement ? Math.round( this.videoElement.duration ) : false;
        },

        mute: function() {
            if(this.videoElement){
                this.videoElement.mute();
            }
        },

        unMute: function() {
            if(this.videoElement){
                this.videoElement.mute();
            }
        },

        onProgress: function() {
            this.model.set('currentTime', this.getCurrentTime());
        },

        onReady: function() {

            var _this = this;

            setTimeout(function(){
                _this.$('.maz-wrapper-mmm-player').removeClass('loading');
            }, 500);

            if(!this.isMobile){
                this.model.set('duration', this.getDuration() );
            }

            var onReadyCallback = this.model.get('onReady');
            if ( _.isFunction(onReadyCallback)) {
                onReadyCallback();
            }

        },

        onPlay: function() {
            this.playInterval = setInterval(_.bind( this.onProgress, this), 200);

            var callback = this.model.get('onPlay');

            if (_.isFunction(callback)) {
                callback();
            }
        },

        onPause: function() {
            clearInterval(this.playInterval);

            var callback = this.model.get('onPause');
            if (_.isFunction(callback)) {
                callback();
            }
        },

        onEnded: function() {
            clearInterval(this.playInterval);

            var callback = this.model.get('onEnded');
            if (_.isFunction(callback)) {
                callback();
            }
        },

        onFullscreenChange: function(e) {
            var callback = this.model.get('onFullscreenChange');
            if (_.isFunction(callback)) {
                callback(e, this.player.isFullScreen);
            }
        },

        onFullscreenChangeMobile: function() {
            var state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
            this.player.isFullScreen = state ? true : false;
            this.onFullscreenChange();
        },

        onShareFacebook: function(){

            var link = this.model.get('shareLink') ? this.model.get('shareLink') : window.location.href;
            var name = this.model.get('shareName') ? this.model.get('shareName') : '';
            var caption = this.model.get('shareCaption') ? this.model.get('shareCaption') : '';
            var description = this.model.get('shareDescription') ? this.model.get('shareDescription') : this.model.get('description');
            var picture = this.model.get('sharePicture') ? (this.model.get('base_url') + this.model.get('assets_url') + this.model.get('sharePicture') ) : '';

            console.log("MMM -> Sharing "+link+" name="+name+" caption="+caption+" description="+description+" picture="+picture);

            FB.ui({
                "method": 'feed',
                "link": link,
                "name": name,
                "caption": caption,
                "description": description,
                "picture": picture
            });

            var callback = this.model.get('onShareFacebook');
            if (_.isFunction(callback)) {
                callback();
            }
        },

        //TODO: factorization of share functions?
        onShareTwitter: function(e) {
            var callback = this.model.get('onShareTwitter');
            if (_.isFunction(callback)) {
                callback(e, this.player.isFullScreen);
            }
        },

        onShareTumblr: function(e) {
            var callback = this.model.get('onShareTumblr');
            if (_.isFunction(callback)) {
                callback(e, this.player.isFullScreen);
            }
        },

        onShareGoogle: function(e) {
            var callback = this.model.get('onShareGoogle');
            if (_.isFunction(callback)) {
                callback(e, this.player.isFullScreen);
            }
        },

        onShareWeibo: function(e) {
            var callback = this.model.get('onShareWeibo');
            if (_.isFunction(callback)) {
                callback(e, this.player.isFullScreen);
            }
        },

        onClickBigPlayButton: function( e ) {
            e.preventDefault();
            this.play();
        }

    });

    return MMMVideoView;
});
